module.exports = __webpack_public_path__ + "img/img.28e441c3.jpg";